export default "__VITE_ASSET__fd5ba337__"